/* @flow */
export default {
    ios: {
        msg: 'Press Cmd+R to reload, Cmd+D or shake for dev menu.',
    },
    android: {
        msg: 'Double tap R on your keyboard to reload. Shake or press menu button for dev menu.',
    },
};
